<div *ngIf="!isH5; else H5temp" class="wrapper">
  <ng-container *ngIf="page != 'home'; else homeTemp">
    <div class="leader-board-btn mutual-opacity onact96" (click)="openBoard()">
      <i></i>
    </div>
    <div class="pop-wrap" [class.open]="open">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ng-container>

  <ng-template #homeTemp>
    <div class="home-wrap">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ng-template>
</div>
<ng-template #H5temp>
  <div class="h5-wrap">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</ng-template>

<ng-template #content>
  <div class="container leader-board" [appLoading]="rankLoading">
    <ng-container *ngIf="topList.length > 0">
      <div class="header">
        <div class="tt">
          <span>{{ 'daily_races' | translate }}</span>
          <div class="word-line"></div>
        </div>
        <div class="btn-close" (click)="open = false">
          <i class="icon-close-simple"></i>
        </div>
      </div>

      <app-scrollbar style="position: relative">
        <div class="list-wrap">
          <div class="list-top">
            <app-img-carousel
              #swiperLeaderBoard
              [config]="swiperOptions"
              class="swiper"
              *ngIf="topList.length > 0"
              [itemsData]="topList"
              (IndexChange)="slideChange($event)"
            >
              <ng-template #carouselItemTpl let-item let-idx="index">
                <div class="img-wrap">
                  <img src="{{ item.bonusImgUrl }}" alt="" />
                  <div class="cover-area">
                    <div>
                      <div class="time-title">{{ 'finish_in' | translate }}</div>
                    </div>
                    <div class="time-zone">
                      <div class="timer">
                        <p class="number">
                          {{
                            remainingTime.day > 0 && remainingTime.day < 10
                              ? '0' + remainingTime.day
                              : remainingTime.day || '00'
                          }}:
                        </p>
                        <p class="text">{{ 'day' | translate }}</p>
                      </div>
                      <div class="timer">
                        <p class="number">
                          {{
                            remainingTime.hour > 0 && remainingTime.hour < 10
                              ? '0' + remainingTime.hour
                              : remainingTime.hour || '00'
                          }}:
                        </p>
                        <p class="text">{{ 'hour' | translate }}</p>
                      </div>
                      <div class="timer">
                        <p class="number">
                          {{
                            remainingTime.min > 0 && remainingTime.min < 10
                              ? '0' + remainingTime.min
                              : remainingTime.min || '00'
                          }}:
                        </p>
                        <p class="text">{{ 'min' | translate }}</p>
                      </div>
                      <div class="timer">
                        <p class="number">
                          {{
                            remainingTime.sec > 0 && remainingTime.sec < 10
                              ? '0' + remainingTime.sec
                              : remainingTime.sec || '00'
                          }}
                        </p>
                        <p class="">{{ 'sec' | translate }}</p>
                      </div>
                    </div>
                    <div class="prize-pool">
                      <div class="tt">
                        {{ 'prize_pool' | translate }}
                      </div>
                      <div class="amount">$100</div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-img-carousel>
            <div style="height: 28px">
              <div id="swiper-pagination" slot="pagination"></div>
            </div>
            <div
              class="button-prev onact96-not"
              [class.disabled]="rankLoading"
              (click)="swiperLeaderBoard?.slidePrev()"
            >
              <div class="box">
                <i class="icon-left-arrow"></i>
              </div>
            </div>
            <div
              class="button-next onact96-not"
              [class.disabled]="rankLoading"
              (click)="swiperLeaderBoard?.slideNext()"
            >
              <div class="box">
                <i class="icon-right-arrow"></i>
              </div>
            </div>
          </div>
          <!-- [appLoading] -->
          <div class="list-content">
            <div class="banner"></div>
            <div class="rule">
              <div class="title onact96" (click)="toggleRule()">
                <div class="left">
                  <i class="icon-warning"></i>
                  <span>{{ 'battles_rules' | translate }}</span>
                </div>
                <i class="arrow icon-right-arrow" [class.up]="showRule"></i>
              </div>
              <ul class="content" *ngIf="showRule">
                <li>
                  <div class="txt gray">{{ topList[selectedActivitIndex].introduction }}</div>
                </li>
                <li>
                  <div class="tt">{{ 'battle_type' | translate }}：</div>
                  <div class="txt">{{ topList[selectedActivitIndex].type }}</div>
                </li>
                <li>
                  <div class="tt">{{ 'level' | translate }}：</div>
                  <div class="txt">{{ 'all_level' | translate }}</div>
                </li>
                <li>
                  <div class="tt">{{ 'currency' | translate }}：</div>
                  <div class="txt">
                    <div class="coin" *ngFor="let item of topList[selectedActivitIndex].currency">
                      <img [src]="item | currencyIcon" lazy="loading" alt="" />
                      {{ item }}
                    </div>
                  </div>
                </li>
                <li>
                  <div class="txt">
                    {{ topList[selectedActivitIndex].content }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="table-wrap" *ngIf="leaderBoardList.length > 0">
              <table>
                <thead>
                  <tr>
                    <th
                      *ngFor="let item of selectTitleData; let index = index"
                      [class.text-left]="index === 0"
                      [class.text-right]="index === listFirstRow.length - 1"
                      [class.text-middle]="index !== 0 && index !== listFirstRow.length - 1"
                      class="text-12"
                    >
                      <ng-container *ngIf="item.icon">
                        <app-tool-tip class="inline-block">
                          <i origin [class]="item.icon" class="mutual-opacity"></i>
                          <p tooltip>{{ item.toolTips }}</p>
                        </app-tool-tip>
                        <span class="ml-6">{{ item.text }}</span>
                      </ng-container>
                      <ng-container *ngIf="!item.icon">
                        {{ item.text }}
                      </ng-container>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of leaderBoardList">
                    <td class="text-middle">
                      <ng-container *ngIf="item?.rankNumber < 4">
                        <img
                          class="badge"
                          [src]="'assets/images/daily-races/' + (item?.rankNumber || 0) + '.svg'"
                          lazy="loading"
                          alt=""
                        />
                      </ng-container>
                      <ng-container *ngIf="item?.rankNumber >= 4">
                        <p class="rank-txt">{{ item?.rankNumber || 0 }}th</p>
                      </ng-container>
                    </td>
                    <td class="">
                      <div class="wrap">
                        <div class="avatar">
                          <img class="" [src]="item.avatar" lazy="loading" alt="" />
                          <p class="text-12">{{ item?.userName || item?.uid || '' }}</p>
                        </div>
                        <div class="players">
                          <ng-container *ngIf="selectedType == 2; else amountType">
                            <p class="text-12 gray-color">{{ item?.rankMoney }}x</p>
                          </ng-container>
                          <ng-template #amountType>
                            <p class="text-12 gray-color">
                              {{ item?.rankMoney || 0 | currencyValue: 'USDT' }}
                              <img [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
                            </p>
                          </ng-template>
                        </div>
                      </div>
                    </td>
                    <td class="text-right">
                      <p class="text-12 inline-block">{{ item?.bonusUsdtMoney || 0 | currencyValue: 'USDT' }}</p>
                      <img class="ml-6" [src]="'USDT' | currencyIcon" lazy="loading" alt="" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="more onact96" (click)="openLeaderBoardPopup()" *ngIf="leaderBoardList.length > 0">
                <span>{{ 'view_more' | translate }}</span>
              </div>
            </div>
            <app-empty class="mt-auto" *ngIf="leaderBoardList.length === 0 && !rankLoading"></app-empty>
          </div>
        </div>
        <div class="relative-games">
          <div class="tt">
            <img src="assets/temp5/icon-game.png" alt="" />
            <span>{{ 'participating_games' | translate }}</span>
            <span class="num">({{ paginator.total }})</span>
          </div>
          <div class="list" [class.two-column]="gameColumn == 2">
            <app-game-unit *ngFor="let item of games" [item]="item"></app-game-unit>
          </div>
          <app-paginator
            [disabled]="gameLoading"
            [loading]="gameLoading"
            [clickLoadMore]="this.clickLoadMore"
            [alwaysH5]="!this.clickLoadMore"
            [(page)]="paginator.page"
            [total]="paginator.total"
            [pageSize]="paginator.pageSize"
            (onPageChange)="getGameByProvider(false)"
          >
          </app-paginator>
        </div>
      </app-scrollbar>
    </ng-container>
  </div>
</ng-template>
